export const PX_BASE = "15px";
